module.exports = __webpack_public_path__ + "img/m5_t1_en.73f9db93.svg";